import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Login.css'; // Asegúrate de que esta hoja de estilo contiene las clases necesarias
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // Importa los íconos de Font Awesome
import axios from '../../axiosConfig';
import { Modal, Button, Form } from 'react-bootstrap';
import { QRCode } from 'qrcode.react';




const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); // Controla la visibilidad de la contraseña
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [showTwoFactorModal, setShowTwoFactorModal] = useState(false);
  const [showActivateTwoFactorModal, setShowActivateTwoFactorModal] = useState(false);
  const [code2FA, setCode2FA] = useState('');
  const [userId, setUserId] = useState(null);
  const [qrImage, setQrImage] = useState('');
  const [secret, setSecret] = useState('');
  const [code, setCode] = useState('');

  const [showActivatePromptModal, setShowActivatePromptModal] = useState(false);
const [showQRModal, setShowQRModal] = useState(false);
  const [user, setUser] = useState(null);


const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const response = await axios.post('/login', { username, password });

    // Siempre guarda el token primero
    localStorage.setItem('token', response.data.access_token);
   

    // Luego maneja el flujo de 2FA
    if (response.data['2fa_required'] === true) {
      setUserId(response.data.user);
      setShowTwoFactorModal(true);
      
    } else {
      setUserId(response.data.user);
      setShowActivatePromptModal(true); // <- primer paso del flujo de activación
    }

      
          
  } catch (error) {
    setError('Error, credenciales inválidas');
  }
};



  
  // Enviar código de verificación 2FA
 const handleVerify2FA = async () => {
  try {
    // 🔹 Limpiar datos anteriores de la sesión ANTES de guardar los nuevos
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('user');
    localStorage.removeItem('role_id');
    localStorage.removeItem('username');
    sessionStorage.removeItem('user'); // por si lo usas en otros lados

    const verifyResponse = await axios.post('/auth/2fa/verify', {
      code,
      user_id: userId, // <- asegúrate de guardar este desde el login
    });

    localStorage.setItem('token', verifyResponse.data.access_token);
    localStorage.setItem('role', verifyResponse.data.role);
    localStorage.setItem(
      'user',
      typeof verifyResponse.data.user === 'string'
        ? verifyResponse.data.user
        : JSON.stringify(verifyResponse.data.user) // por si viene como objeto
    );
    localStorage.setItem('role_id', verifyResponse.data.role_id);
    localStorage.setItem('username', verifyResponse.data.username);

    setShowTwoFactorModal(false);
    navigate('/peticiones');
  } catch (error) {
    setError('Código 2FA incorrecto.');
  }
};

  
  

  const handleActivate2FA = async () => {
    try {
      const response = await axios.get('/auth/2fa/generate', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
  
      setQrImage(response.data.qr_image); // Solo guardamos el secreto recibido
  
      setShowActivatePromptModal(false); // Cerramos el modal de activación
      setShowQRModal(true);              // Abrimos el modal que contiene el QR generado en frontend
  
    } catch (error) {
      setError('Error al generar el secreto para 2FA');
    }
  };
  
  

 
  const handleConfirmDeviceRegistration = () => {
    setShowQRModal(false);
    setShowTwoFactorModal(true); // Mostrar modal donde se introduce el código
    setCode(''); // Limpiar campo de código anterior
    setError('');
  };
  
  
  // const handleContinueWithout2FA = async () => {
  //   // Aquí debes repetir la llamada de login para obtener los datos nuevamente
  //   const response = await axios.post('/login', { username, password });

  //   localStorage.setItem('token', response.data.access_token);
  //   localStorage.setItem('role', response.data.role);
  //   localStorage.setItem('user', response.data.user);
  //   localStorage.setItem('role_id', response.data.role_id);
  //   localStorage.setItem('username', response.data.username);
    


  //   setShowActivateTwoFactorModal(false);
  //   navigate('/peticiones');
  // };

  const handleContinueWithout2FA = async () => {
  // 🔹 Limpiar datos anteriores de la sesión
  localStorage.removeItem('token');
  localStorage.removeItem('role');
  localStorage.removeItem('user');
  localStorage.removeItem('role_id');
  localStorage.removeItem('username');

  // (opcional pero recomendado) limpia también el user en sessionStorage
  sessionStorage.removeItem('user');

  // Aquí debes repetir la llamada de login para obtener los datos nuevamente
  const response = await axios.post('/login', { username, password });

  localStorage.setItem('token', response.data.access_token);
  localStorage.setItem('role', response.data.role);
  localStorage.setItem('user', 
    typeof response.data.user === 'string'
      ? response.data.user
      : JSON.stringify(response.data.user) // por si viene como objeto
  );
  localStorage.setItem('role_id', response.data.role_id);
  localStorage.setItem('username', response.data.username);

  setShowActivateTwoFactorModal(false);
  navigate('/peticiones');
};

  // Función para alternar la visibilidad de la contraseña
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };


  // arriba del return:
const inputRefs = React.useRef([]);
const LENGTH = 6;

const handleChange = (i, val) => {
  const value = val.replace(/[^0-9]/g, "").slice(0, 1); // solo 1 dígito numérico
  const arr = code.split("");
  arr[i] = value;
  const next = arr.join("");
  setCode(next);
  if (value && inputRefs.current[i + 1]) inputRefs.current[i + 1].focus();
};

const handleKeyDown = (i, e) => {
  if (e.key === "Backspace" && !code[i] && inputRefs.current[i - 1]) {
    inputRefs.current[i - 1].focus();
  }
};

const handlePaste = (e) => {
  e.preventDefault();
  const pasted = (e.clipboardData.getData("text") || "")
    .replace(/\D/g, "")
    .slice(0, LENGTH);
  const arr = new Array(LENGTH).fill("");
  for (let j = 0; j < pasted.length; j++) arr[j] = pasted[j];
  setCode(arr.join(""));
  inputRefs.current[Math.min(pasted.length, LENGTH - 1)]?.focus();
};
  const toImgSrc = (val) => {
  if (!val) return '';
  // Ya es data URI PNG o SVG -> usar tal cual
  if (val.startsWith('data:image/')) return val;
  // Viene un SVG en texto ("<svg ..." o "<?xml ...")
  if (val.startsWith('<svg') || val.startsWith('<?xml')) {
    return 'data:image/svg+xml;utf8,' + encodeURIComponent(val);
  }
  // Por si te llega SVG pero ya URL-encoded sin prefijo
  if (val.startsWith('%3Csvg') || val.startsWith('%3C?xml')) {
    return 'data:image/svg+xml;utf8,' + val; // ya está encoded
  }
  return val; // fallback
};


  return (
    <div className="login-wrapper">
      <div className="login-container">
        <img src="/IMG/Simedimos_Logo_var3.png" alt="Logo" className="login-logo" />
        <h2 className="login-title">Iniciar sesión</h2>
        <form onSubmit={handleSubmit} className="form-signin">
          <div className="form-group">
            <input 
              type="text" 
              id="inputUser" 
              className="form-control" 
              placeholder="Nombre de Usuario" 
              required 
              autoFocus 
              value={username} 
              onChange={(e) => setUsername(e.target.value)} 
            />
          </div>
          <div className="form-group password-wrapper">
            <input 
              type={showPassword ? 'text' : 'password'} // Cambia entre password y text
              id="inputPassword" 
              className="form-control" 
              placeholder="Contraseña" 
              required 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
            />
            <span className="password-toggle-icon" onClick={togglePasswordVisibility}>
              {showPassword ? <FaEyeSlash /> : <FaEye />} {/* Cambia el ícono */}
            </span>
          </div>
          
          {error && <p className="text-danger">{error}</p>}
          <button className="btn btn-lg btn-primary btn-block" type="submit">Iniciar Sesión</button>
        </form>
         {/* Modal para introducir código 2FA */}
      {/* <Modal show={showTwoFactorModal} onHide={() => setShowTwoFactorModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Autenticación de dos pasos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Introduce el código generado por tu aplicación</Form.Label>
            <Form.Control
              type="text"
              placeholder="Código 2FA"
              value={code}
              onChange={(e) => setCode(e.target.value)}

            />
          </Form.Group>
          {error && <p className="text-danger mt-2">{error}</p>}
        </Modal.Body>
        <Modal.Footer>
        <div className="d-flex justify-content-between" >
          
          <Button variant="primary" onClick={handleVerify2FA}>
            Verificar código
          </Button>
          </div>
        </Modal.Footer>
      </Modal> */}


      <Modal show={showTwoFactorModal} onHide={() => setShowTwoFactorModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Autenticación de dos pasos</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <Form.Group>
     <Form.Label
  style={{
    fontSize: "0.85rem",   // más pequeño
    fontWeight: "bold",    // negrita
    marginLeft: "5px",     // sangría
  }}
>
  Código de seguridad F2A
</Form.Label>


      <div className="d-flex align-items-center justify-content-center gap-2" onPaste={handlePaste}>
        {Array.from({ length: LENGTH }).map((_, i) => (
          <React.Fragment key={i}>
            {i === 3 && <span className="mx-2">-</span>}
            <Form.Control
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={1}
              value={code[i] || ""}
              ref={(el) => (inputRefs.current[i] = el)}
              onChange={(e) => handleChange(i, e.target.value)}
              onKeyDown={(e) => handleKeyDown(i, e)}
              style={{
                width: 48,
                height: 48,
                textAlign: "center",
                fontSize: 22,
              }}
            />
          </React.Fragment>
        ))}
      </div>
    </Form.Group>

    {error && <p className="text-danger mt-2">{error}</p>}
  </Modal.Body>

  <Modal.Footer>
    <Button variant="primary" onClick={() => handleVerify2FA(code)}>
      Verificar código
    </Button>
  </Modal.Footer>
</Modal>


      <Modal show={showActivatePromptModal} onHide={() => setShowActivatePromptModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Activar verificación de dos pasos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>No tienes activada la verificación de dos pasos. ¿Quieres activarla ahora?</p>
        <div className="d-flex justify-content-center gap-2">
  <Button variant="primary" size="sm" onClick={handleActivate2FA}>
    Sí, activar ahora
  </Button>
  <Button variant="secondary" size="sm" onClick={handleContinueWithout2FA}>
    No, continuar sin activar
  </Button>
</div>

      </Modal.Body>
    </Modal>

    <Modal show={showQRModal} onHide={() => setShowQRModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Escanea el código QR</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    
      <>
        <p>Escanea este código con Google Authenticator o una app similar.</p>
        <div className="text-center my-3">
          {qrImage && (
                <img src={toImgSrc(qrImage)} alt="QR 2FA" width={200} height={200} />
              )}
        </div>


        <p className="text-muted">
          Luego de escanear el código, haz clic en <strong>Confirmar</strong> para introducir tu código 2FA.
        </p>

        {error && <p className="text-danger">{error}</p>}

        <div className="d-flex justify-content-between">
         

          <Button variant="primary" onClick={handleConfirmDeviceRegistration} className="ms-2">
            Confirmar
          </Button>
        </div>
      </>
    
  </Modal.Body>
</Modal>




        {/* <p className="register-text mt-3">
          ¿No tienes una cuenta?{' '}
          <Link to="/register" className="register-link">
            Crear nueva Cuenta
          </Link>
        </p> */}
      </div>
    </div>
  );
};

export default Login;
